import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import styles from './HpContactsTicketNotNewDialog.module.scss'

interface IHpContactsTicketNotNewDialogProps {
  isShow: boolean
  onClose: () => void
}

export const HpContactsTicketNotNewDialog = ({
  isShow,
  onClose,
}: IHpContactsTicketNotNewDialogProps) => {
  return (
    <ModalDialog
      show={isShow}
      onClose={onClose}
      size={'xs'}
      content={() => (
        <div>
          <p className={styles.warning__title}>Warning!</p>
          <p className={styles.warning__text}>
            <Translation text="jbp-salesteam-ticket-not-new" />
          </p>
          <div className={styles.warning__buttons}>
            <Button
              variant={'contained'}
              className={styles.warning__close}
              onClick={onClose}
              color={'grey'}
            >
              OK
            </Button>
          </div>
        </div>
      )}
    />
  )
}
